const EXACT_PATHS = [
    '/audacity/auth/sign-in',
    '/audacity/auth/sign-up',
    '/audacity/link',
    '/audacity/post-download',
    '/audacity/postdownload',
    '/oauth/consent',
    '/tour',
]

const EMBEDDED_AUDIO_PATH = /^\/embed\/(v2\/)?audio\/[-a-zA-Z0-9@:%._+~#=]{1,256}$/
const EMBEDDED_COLLECTION_PATH = /^\/embed\/(v2\/)?collection\/[-a-zA-Z0-9@:%._+~#=]{1,256}$/

export const isConsentExemptPath = (pathname: string): boolean =>
    EXACT_PATHS.includes(pathname) ||
    EMBEDDED_AUDIO_PATH.test(pathname) ||
    EMBEDDED_COLLECTION_PATH.test(pathname)
